import React from "react"
import { formatPhoneNumber } from "@/utils/FormatPhoneNumber"
import { getDisplayAddress } from "@/utils/addresses"
import { LocationDetailsType } from "@/types/orders.types"
import { CountryCode } from "libphonenumber-js"
import { message } from "antd"
import { useTranslation } from "react-i18next"

interface LocationDetailsProps {
  id: string
  alias: string
  buildingNumber?: string
  countryCode?: string
  name: string
  address: string
  phone: string
  email?: string
}

const LocationDetails: React.FC<LocationDetailsProps> = ({
  id,
  alias,
  name,
  countryCode,
  address,
  buildingNumber,
  phone,
  email,
}) => {
  const { t } = useTranslation()
  const handleLocationIdCopy = (locationId: string) => {
    navigator.clipboard?.writeText(locationId)
    message.success(t("common.copied"))
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <p className="font-semibold">{alias}</p>
        {!!id && (
          <span
            onClick={() => handleLocationIdCopy(id)}
            className="text-sm text-gray-500 underline decoration-dotted cursor-pointer hover:bg-gray-50 p-1.5 rounded-md"
          >
            id: {id}
          </span>
        )}
      </div>
      <p>{name}</p>
      <p>
        {getDisplayAddress({
          address: address,
          buildingNumber: buildingNumber,
        } as LocationDetailsType)}
      </p>
      <p>{formatPhoneNumber(phone, countryCode as CountryCode)}</p>
      {!!email && <p>{email}</p>}
    </div>
  )
}

export default LocationDetails
